import React from "react";
import * as EncryBase from "../../wea-tools/Encry.base";
const { Encry } = EncryBase;
class Main extends React.Component {
  render() {
    return (
      <Encry
        {...this.props}
        prefixCls="wea-input-auth"
        ecId={`${this.props.ecId}_Encry@3dsdq6`}
        encryType="INPUT"
      />
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-input-auth/index.js